<template lang="pug">
  .filter-multiselect#filter-multiselect(:class="{'is-empty': !selectedData.length}")
    label.typo__label(for="filter-multiselect")
    multiselect(
      v-model="selectedData"
      id="ajax"
      :label="label"
      :trackBy="trackBy"
      open-direction="bottom"
      :options="options"
      :multiple="multiple"
      :searchable="searchable"
      :loading="isLoading"
      :max-height="500"
      :show-no-results="true"
      :close-on-select="closeOnSelect"
      :hide-selected="hideSelected"
      :clear-on-select="true"
      :disabled="disabled"
      :selectLabel="selectLabel"
      :placeholder="placeholder"
    )
</template>

<script>
import { mapGetters } from 'vuex'
import { gettext } from '@/services/TranslateHandler'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
const _ = require('lodash')

export default {
  name: 'FilterMultiselect',
  components: {
    Multiselect
  },
  data () {
    return {
      selectedData: [],
      isLoading: false,
      placeholder: 'Select option'
    }
  },
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    returnItem: {
      default: ''
    },
    disabled: {
      default: false
    },
    value: {
      default: () => {
        return []
      }
    },
    labelText: {
      default: gettext('Select option')
    },
    searchable: {
      default: false
    },
    multiple: {
      default: true
    },
    label: {
      default: 'name'
    },
    trackBy: {
      default: 'id'
    },
    closeOnSelect: {
      default: false
    },
    selectLabel: {
      default: ''
    },
    hideSelected: {
      default: true
    },
    option: {
      default: ''
    }
  },
  methods: {
    gettext: gettext,
    setData (value, items) {
      if (_.isArray(value)) {
        let result = []
        for (let item of value) {
          let val = _.find(items, {'id': item})
          if (val) result.push(val)
        }
        this.selectedData = result
      } else {
        this.selectedData = _.find(items, {'id': parseInt(value)})
      }
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    options () {
      let items = this.items
      if (this.option) items.unshift({name: this.option, id: null, isDefault: true})
      return items
    }
  },
  watch: {
    getLanguage () {
      this.placeholder = this.labelText || gettext('Select option')
    },
    selectedData: {
      deep: true,
      handler: function (value) {
        this.$emit('input', value)
      }
    },
    items: function (val) {
      if (val.length) {
        let item = _.find(val, {id: this.selectedData.id})
        if (item) this.selectedData = item
      }
    },
    value: function (val) {
      if (!_.isObject(val) && ~val) {
        this.setData(val, this.items)
      } else if (!~val) {
        this.selectedData = this.option ? {name: this.option, id: null, isDefault: true} : {}
      }
    }
  },
  created () {
    this.placeholder = this.labelText || gettext('Select option')
  }
}
</script>

<style lang='scss'>
  .filter-multiselect {
    .multiselect {
      &.multiselect--active {
        .multiselect__content-wrapper {
          position: absolute !important;
        }
      }
      .multiselect__tag{
        background: #ededed;
        span{
          color: #000;
        }
        .multiselect__tag-icon{
          &:after{
            color: #bb1d2c;
          }
          &:hover, &:focus{
            background: #cccccc;
          }
        }
      }
      .multiselect__option--highlight{
        background: #bb1d2c;
        color: #e0e0e0;
        &:hover{
          color: #e0e0e0;
        }
        &:after{
          background: #ededed;
          color: #000;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/search/components/searchable-select/index.vue